<template>
  <div class="pdp-accordion-container">
    <v-expansion-panels v-model="active" accordion tile>
      <v-expansion-panel>
        <v-expansion-panel-header
          class="title-semibold text-title"
          hideActions
        >
          <div class="pdp-accordion-title">
            <div :class="[{ 'show-label': isShowLabelExpand }]">
              <span
                v-if="isShowLabelExpand"
                class="pdp-accordion-title-label-icon"
              >
                {{
                  active == 0
                    ? 'ซ่อนรายการสั่งซื้อ'
                    : 'แสดงรายการสั่งซื้อ'
                }}
              </span>
              <v-icon class="pdp-accordion-title-icon"
                >mdi-chevron-down</v-icon
              >
            </div>
            <slot name="title"></slot>
          </div>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <div class="pdp-accordion-content">
            <slot name="content"></slot>
          </div>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </div>
</template>

<script>
export default {
  name: 'CheckoutSummaryStickyAccordion',

  props: {
    isShowLabelExpand: {
      type: Boolean,
      default: false,
    },
  },

  inject: {
    defaultActive: {
      type: [Number, String],
      default: 0,
    },
  },

  data() {
    return {
      active: false, // this.defaultActive,
    }
  },
}
</script>

<style lang="stylus" scoped>
.pdp-accordion-container{
    .pdp-accordion-title{
        display: flex;
        justify-content: space-between;
        align-items: center;
        max-width: 570px;
        margin: 0 auto;
        padding: 22px 21px;

        .pdp-accordion-title-icon{
            font-size 14px
            padding 6px
        }

        .pdp-accordion-title-label-icon {
            font-size: 14px;
            font-weight: 400;
            color: $color-bnn;
        }
    }

    .pdp-accordion-content{
        max-width: 570px;
        margin: 0 auto;
    }

    ::v-deep {
        .v-expansion-panel {
            // border: none !important;
            background-color: transparent;
        }

        .v-expansion-panel::before {
            box-shadow: none;
        }

        .v-expansion-panels .v-expansion-panel::after {
            border: none;
        }

        .v-expansion-panels .v-expansion-panel:not(:last-child):not(:first-child) {
            border-bottom: 1px solid rgba(0,0,0,.08);
            border-right: none;
            border-left: none;
        }

        .v-expansion-panel-header{
            padding: 0;
            min-height: fit-content;
        }

        .v-expansion-panel-content .v-expansion-panel-content__wrap{
            padding: 0 0 16px 0;
        }

        .v-expansion-panels .v-expansion-panel:first-child {
            border-top: 1px solid rgba(0,0,0,.08);
            border-bottom: 1px solid rgba(0,0,0,.08);
        }

        .v-expansion-panels .v-expansion-panel:last-child {
            border-bottom: 1px solid rgba(0,0,0,.08);
        }

        .v-expansion-panel-header {
            color: rgba(18,18,18,.75);

            .pdp-accordion-title-icon{
                color: rgba(18,18,18,.75);
            }
        }

        .v-item--active .v-expansion-panel-header {
            // color: $color-bnn !important;
            border-bottom: 1px solid rgba(0,0,0,.08);

            .pdp-accordion-title-label-icon{
                color: $color-bnn;
            }

            .pdp-accordion-title-icon{
                color: $color-bnn;
                transform: rotate(180deg);
            }

            .show-label{
                .pdp-accordion-title-icon{
                    // color: rgba(18,18,18,.75);
                    transform: rotate(180deg);
                }
            }

        }
    }
}
</style>
